import React from 'react';
import { Box, Typography } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { isAuthenticated } from '../../utils/auth';

const Footer = ({ sidebarOpen = false }) => {
  const location = useLocation();
  const authenticated = isAuthenticated();
  const isLoginPage = location.pathname === '/login';

  if (isLoginPage) {
    return null;
  }

  return (
    <Box
      component="footer"
      sx={{
        py: 2,
        px: 3,
        backgroundColor: '#f5f5f5',
        borderTop: '1px solid #e0e0e0',
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        position: 'fixed',
        bottom: 0,
        left: authenticated && sidebarOpen ? '250px' : '0px',
        right: 0,
        zIndex: 1000,
        transition: 'left 0.3s',
      }}
    >
      <Typography variant="body2" sx={{ color: '#666666', fontSize: '12px' }}>
        © {new Date().getFullYear()}. All Rights Reserved.
      </Typography>
    </Box>
  );
};

export default Footer;

